import styled from 'styled-components';

const H2 = styled.h2`
  font-size: 1.5em;
`;

export default H2;
